import { api_GET, api_POST, api_PUT } from './_api';

const coletasRecusadas_api = {
    GetList: (transportadorId = 0, filtros = { dataInicila: null, dataFinal: null }) => {
        const promise = new Promise((resolve, reject) => {
            api_POST(`ColetaRecusada/GetList/${transportadorId}`, filtros)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    GetItem: (id) => {
        const promise = new Promise((resolve, reject) => {
            api_GET(`ColetaRecusada/GetItem/${id}`)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    AlterarDestinoOrdemRecusada: (destinoId, recusaId) => {
        const promise = new Promise((resolve, reject) => {
            api_PUT(`ColetaRecusada/AlterarDestinoOrdemRecusada/${destinoId}/${recusaId}`)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    AlterarVeiculoOrdemRecusada: (veiculoId, recusaId) => {
        const promise = new Promise((resolve, reject) => {
            api_PUT(`ColetaRecusada/AlterarVeiculoOrdemRecusada/${veiculoId}/${recusaId}`)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    BaixaPendenciaOrdemRecusada: (recusaId, justificativa) => {
        const promise = new Promise((resolve, reject) => {
            api_PUT(`ColetaRecusada/BaixaPendenciaOrdemRecusada/${recusaId}`, justificativa)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    ComprovarDestinacao: (model) => {
        const promise = new Promise((resolve, reject) => {
            api_PUT(`ColetaRecusada/ComprovarDestinacao`, model)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
}

export default coletasRecusadas_api;